module.exports = __webpack_public_path__ + "img/video_1.a8fda138.jpg";